import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const BodyWrapper = styled.div`
  display: flex;
  flex: 1;
  position: relative;
  justify-content: center;
  padding: 0 1em;
`;

export const BodyInner = styled.div`
  display: flex;
  width: 100%;
  max-width: 1580px;
`;

export const ContentWrapper = styled.div`
  flex: 1;
  position: relative;
  z-index: ${BaSeTheme.stackOrder.normal};
`;

export const GuidanceSidebar = styled.div`
  width: 300px;
  flex-shrink: 0;
  margin: 1em auto auto auto;
`;

export const GuidanceDrawerWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
`;
